import { render, staticRenderFns } from "./AppsAvailable.vue?vue&type=template&id=6060f94a"
import script from "./AppsAvailable.vue?vue&type=script&lang=js"
export * from "./AppsAvailable.vue?vue&type=script&lang=js"
import style0 from "./AppsAvailable.vue?vue&type=style&index=0&id=6060f94a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports